<template>
  <div>
    <div class="col s12 m6 l4">
      <div class="card sticky-action" style="width:100%;">
        <table>
          <div @submit.prevent="Get_publ_intermediate_DB">
            <caption class="messageoutput">ОТЧЕТ №1 «КОЛИЧЕСТВО ОБУЧАЮЩИХСЯ СТУДЕНТОВ В РАЗРЕЗЕ ФАКУЛЬТЕТОВ, СПЕЦИАЛЬНОСТЕЙ И ПРЕДМЕТОВ»</caption>
            <tr>
              <td colspan="3">
                <span class="form_description">
                Для формирования отчета укажите e-mail адрес, на который поступит отчет, затем нажмите на кнопку 'Сформировать отчет'.<br>
                Отчет поступит на указанную Вами электронную почту в формате Excel.<br>
                </span>
                </td>
            </tr>
            <tr>
              <td>E-mail адрес, на который поступит отчет после его формирования:
                <span class="input-field">
                  <span>
                    <input type="email" v-model="emailReportTo" id="email_1" name="email" style="width:240px; height:18px;" placeholder="name@corp.nstu.ru" class="card-content red-text" :class="{ invalid: ( $v.emailReportTo.$dirty && !$v.emailReportTo.required ) || ( $v.emailReportTo.$dirty && !$v.emailReportTo.email ) }">
                    <small
                      class="helper-text invalid"
                      v-if="$v.emailReportTo.$dirty && !$v.emailReportTo.required && flag===0"
                    >Поле email является обязательным для заполнения!
                    </small>
                    <small
                      class="helper-text invalid"
                      v-else-if="$v.emailReportTo.$dirty && !$v.emailReportTo.email"
                    >Введите корректный email
                    </small>
                  </span>
                </span>
              </td>
              <td>
                <button :disabled="isButtonDisabledGetReportOthers1" class="btn-small btn-primary light-blue" @click="Get_Report_Others1">Сформировать отчет<i class="material-icons right">receipt</i></button>
              </td>
            </tr>
          </div>
          <tr>
            <div v-if="GetReportOthers1status === 3">
                  <span class="messageoutput">Отчет формируется и поступит на указанную Вами электронную почту </span>
              <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
            </div>
            <!--              </td>-->
          </tr>
          <!--API ключ для доступа к серверной части приложения (Backend) некорректный.-->
          <div v-if="GetReportOthers1status === 5">
            <tr>
              <td class="helper-text invalid">
                Ошибка доступа! API ключ для доступа к серверной части приложения (Backend) некорректный. Пожалуйста, обратитесь к администратору системы.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
          <!--В процессе операции (на стороне backend) произошла ошибка. Пожалуйста, обратитесь к администратору системы.-->
          <!--Не удается подключиться к серверу.-->
          <div v-else-if="GetReportOthers1status === 6">
            <tr>
              <td class="helper-text invalid">
                Не удается подключиться к серверу. Пожалуйста, попробуйте еще раз, сейчас или позже.
                <button type="button" @click="cleaningForm"><i>закрыть информацию</i></button>
              </td>
            </tr>
          </div>
        </table>
      </div>
    </div>
  </div>
</template>

<style>
  .align_items {
    align-items: center;
  }
  .messageoutput {
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    color: #013f28;
    font-weight:bold;
  }
  .form_description{
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 120%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    color: #013f28;
    font-style: italic; /* Курсивное начертание */
  }
  /*table, th, td, tr {*/
  /*  border: 1px solid black;*/
  /*}*/
</style>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { KEY } from '../../keys.js'
import { URLB } from '../../url'
export default {
  data () {
    return {
      loading_32: true,
      isButtonDisabledGetReportOthers1: false, /* блокировка нажатия кнопки 'Выгрузить публикации' ИЗНАЧАЛЬНО: активная */
      XELSCODE: 0,
      emailReportTo: '',
      GetReportOthers1: 0,
      GetReportOthers1status: 0,
      flag: 0
    }
  },
  validations: {
    emailReportTo: {
      required, email
    }
  },
  methods: {
    Get_Report_Others1 () {
      this.flag = 0
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.loading_32 = false
      var emailReportTo
      emailReportTo = this.emailReportTo
      this.statusGetReportOthers1 = 0
      const apiKeyBack = KEY.APIKEY_BACKEND
      const urlBack = URLB.URL_BACKEND
      this.$http.get(`${urlBack}/api/content/report_students_faculty/email/${emailReportTo}?apiKey=${apiKeyBack}`)
        .then(response => {
          this.loading_32 = true
          // console.log(response.json())
          return response.json()
        })
        .catch(error => {
          console.log(error)
          this.GetReportOthers1status = 6
        })
        .then(GetReportOthers1 => {
          this.GetReportOthers1 = GetReportOthers1
          // console.log(GetReportOthers1)
          this.statusGetReportOthers1 = GetReportOthers1.X_ELS_CODE
          // console.log(GetReportOthers1.file_name)
          if (this.statusGetReportOthers1 === 3) {
            this.GetReportOthers1status = 3
            return
          }
          if (this.statusGetReportOthers1 === 5) {
            this.GetReportOthers1status = 5
          }
        })
    },
    cleaningForm () {
      this.emailReportTo = ''
      this.GetReportOthers1status = ''
      this.XELSCODE = 0
      this.loading_32 = true
      this.flag = 1
    }
  }
}
</script>
